import { useLayoutEffect, useRef } from "react";

/** Syncs --topbar-block-height / --main-scroll-top from the fixed top bar shell. */
export function useTopBarInset<T extends HTMLElement>() {
  const ref = useRef<T>(null);

  useLayoutEffect(() => {
    const node = ref.current;
    if (!node) return;

    const sync = () => {
      const height = Math.ceil(node.getBoundingClientRect().height);
      document.documentElement.style.setProperty(
        "--topbar-block-height",
        `${height}px`,
      );
    };

    sync();
    const ro = new ResizeObserver(sync);
    ro.observe(node);
    return () => ro.disconnect();
  }, []);

  return ref;
}

/** Syncs --mobile-nav-measured from the overlaid bottom nav dock. */
export function useMobileNavInset<T extends HTMLElement>() {
  const ref = useRef<T>(null);

  useLayoutEffect(() => {
    const node = ref.current;
    if (!node) return;

    const sync = () => {
      const height = Math.ceil(node.getBoundingClientRect().height);
      document.documentElement.style.setProperty(
        "--mobile-nav-measured",
        `${Math.max(height, 0)}px`,
      );
    };

    sync();
    const ro = new ResizeObserver(sync);
    ro.observe(node);
    return () => ro.disconnect();
  }, []);

  return ref;
}
